import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface PortalCodeType {
	commCdId: string;
	commCdNm: string;
	commCdOrder: string;
	commCdAttr: string;
	commCdExpl: string;
	commCdAttr2: string;
	commCdExpl2: string;
	commCdAttr3: string;
	commCdExpl3: string;
	commCdAttr4: string;
	commCdExpl4: string;
	commCdAttr5: string;
	commCdExpl5: string;
	commCdAttr6: string;
	commCdExpl6: string;
	commCdAttr7: string;
	commCdExpl7: string;
	commCdAttr8: string;
	commCdExpl8: string;
}

/** ```
 * 공통 코드 조회
 *   `/esntl/common/code/${cmmnGrpCode}`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/
const key = `useCode`;
const getPath = (cmmnGrpCode: string): string | null => {
	if (!cmmnGrpCode) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/portal/common/code/${cmmnGrpCode}`;
};

/** ```
 * 공통 코드 조회
 *   `/esntl/common/code/${cmmnGrpCode}`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/
const usePortalCode = (cmmnGrpCode: string, options?: Partial<UseQueryOptions<Response<PortalCodeType[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(cmmnGrpCode)],
		queryFn: () => useConfigureAxios({url: getPath(cmmnGrpCode)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default usePortalCode;
export {getPath, key};
export type {PortalCodeType};
